import React from 'react';

export default ({ input, label, labelStyle, id, wide, className, meta: { touched, initial, error } }) => {
  const color = (touched && error && 'red') || '#000';

  return (
    <div className={(wide && 'col-md-12') || className} style={wide && { textAlign: 'center' }}>
      <div className='md-form'>
        <input type='checkbox' checked={initial} {...input} id={id} />
        <label htmlFor={id} style={{ color, ...labelStyle }}>
          {label}
        </label>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/application-form/field-components/checkbox.js